module.exports = __webpack_public_path__ + "img/okcupid.69e2b39.png";